import AuthService from '@/services/auth.service'
import cuentaService from '@/services/cuenta.service'

export default {
  namespaced: true,
  state: {
    estaModalAbierto: false,
    sesion: JSON.parse(localStorage.getItem('sesion')) || {},
    token: localStorage.getItem('token') || '',
    estado: '',
    bodega: JSON.parse(localStorage.getItem('bodega')) || {},
    auth: new AuthService()
  },
  getters: {
    estaAutentificado: (state) => !!state.token,
    estado: (state) => state.estado,
    estaModalAbierto: (state) => state.estaModalAbierto,
    sesion: (state) => state.sesion,
    bodega: (state) => state.bodega,
    estaAutentificando: (state) => state.estado === 'loading',
    puedeCambiarBodega: (state) => state.sesion.bodegas?.length > 1 || false,
    esValida: (state) =>
      state.sesion &&
      Object.keys(state.sesion).length > 0 &&
      Object.getPrototypeOf(state.sesion) === Object.prototype
  },
  mutations: {
    CHANGE_BODEGA_OPEN(state) {
      state.estaModalAbierto = true
    },
    CHANGE_BODEGA_CLOSE(state) {
      state.estaModalAbierto = false
    },
    LOGIN_REQUEST: (state) => (state.estado = 'loading'),
    LOGIN_SUCCESS: (state, payload) => {
      state.estado = 'success'
      state.token = payload.token
      state.sesion = payload.sesion
      localStorage.setItem('token', payload.token)
      localStorage.setItem('sesion', JSON.stringify(payload.sesion))
    },
    LOGIN_SESSION_SUCCESS: (state, payload) => {
      state.estado = 'success'
      state.sesion = payload.sesion
      state.bodega = payload.bodega
      localStorage.setItem('sesion', JSON.stringify(payload.sesion))
      localStorage.setItem('bodega', JSON.stringify(payload.bodega))
    },
    LOGIN_ERROR: (state) => (state.estado = 'error'),
    LOGOUT: (state) => {
      localStorage.removeItem('token')
      localStorage.removeItem('sesion')
      localStorage.removeItem('bodega')
      state.estado = ''
      state.token = ''
    },
    REFRESH_TOKEN_REQUEST: (state) => (state.estado = 'loading'),
    REFRESH_TOKEN_SUCCESS: (state, payload) => {
      state.estado = 'success'
      state.token = payload.token
      localStorage.setItem('token', payload.token)
    }
  },
  actions: {
    login: async ({ commit, state }) => {
      commit('LOGIN_REQUEST')
      await state.auth
        .login()
        .then(async (response) => {
          const sesion = {
            id: response.account.homeAccountId,
            nombreUsuario: response.account.username,
            nombre: response.account.name,
            roles: [],
            bodegas: []
          }
          const token = await state.auth.getToken()
          commit('LOGIN_SUCCESS', { token, sesion })
        })
        .catch((err) => {
          commit('LOGIN_ERROR', err)
          commit('LOGOUT')
          throw new Error(err)
        })
    },
    getSesion: async (
      { commit, state },
      { nombreUsuario, bodega = '' } = {}
    ) => {
      commit('LOGIN_REQUEST')
      await cuentaService
        .getSesion(nombreUsuario, bodega)
        .then((response) => {
          const sesion = state.sesion
          sesion.roles = response.data.roles
          const bodegas = []
          for (const element of response.data.bodegas) {
            if (!bodegas.some((item) => item.codigo === element.codigo))
              bodegas.push(element)
          }
          sesion.bodegas = bodegas

          let actual = response.data.bodegas.find((item) => item.id === bodega)
          if (!actual) actual = response.data.bodegas[0]
          commit('LOGIN_SESSION_SUCCESS', { sesion, bodega: actual })
        })
        .catch((err) => {
          commit('LOGIN_ERROR', err)
          commit('LOGOUT')
          throw new Error(err)
        })
    },
    logout: async ({ commit, state }) => {
      commit('LOGOUT')
      await state.auth.logout()
    },
    cambiarBodegaAsync({ commit }) {
      commit('CHANGE_BODEGA_OPEN')
    },
    refreshToken: async ({ commit, state }) => {
      commit('REFRESH_TOKEN_REQUEST')
      try {
        const token = await state.auth.getToken()
        commit('REFRESH_TOKEN_SUCCESS', { token })
        return token
      } catch (err) {
        commit('LOGIN_ERROR', err)
        throw new Error(err)
      }
    }
  },
  modules: {}
}
